<section class="services">
    <div class="services-header" appFadeInReveal>
        <h1>Mis Servicios de Psicología</h1>
        <p>
            Ofrezco un espacio seguro y profesional adaptado a cada etapa vital. 
            Selecciona el área en la que necesitas ayuda para conocer cómo trabajo.
        </p>
    </div>

    <div class="services-general">
        <div class="services-grid">
            
            <a [routerLink]="['/servicios/terapia-infantil']" class="service-card" tabindex="0" appFadeInReveal>
                <img src="/services_title_01.webp" alt="Psicólogo infantil Santander" class="photo--mask" fetchpriority="high" decoding="async">
                <h3>Atención en la infancia</h3>
            </a>

            <a [routerLink]="['/servicios/terapia-adolescentes']" class="service-card" tabindex="0" appFadeInReveal>
                <img src="/services_title_02.webp" alt="Psicólogo adolescentes Santander" class="photo--mask" fetchpriority="high" decoding="async">
                <h3>Atención en la adolescencia</h3>
            </a>

            <a [routerLink]="['/servicios/terapia-adultos']" class="service-card" tabindex="0" appFadeInReveal>
                <img src="/services_title_03.webp" alt="Psicólogo adultos Santander" class="photo--mask" fetchpriority="high" decoding="async">
                <h3>Atención en edad adulta</h3>
            </a>

        </div>
    </div>
</section>